import { FLASHES } from "../../../mocks/newsData";

export default function BreakingTicker() {
  const list = [...FLASHES, ...FLASHES];

  return (
    <section className="relative overflow-hidden border-b-2 border-foreground-950 bg-primary-500 text-background-50" aria-label="最新滚动快讯">
      <div className="mx-auto flex max-w-[1440px] items-stretch px-4 md:px-6">
        <div className="z-10 flex shrink-0 items-center gap-2 py-2.5 pr-4">
          <span className="h-2 w-2 animate-pulseDot rounded-full bg-background-50" aria-hidden="true" />
          <span className="whitespace-nowrap font-heading text-sm font-black tracking-wide">最新快讯</span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-ticker gap-12 py-2.5 pl-2">
            {list.map((flash, index) => (
              <span key={index} className="flex items-center gap-3 whitespace-nowrap text-sm">
                <i className="ri-flashlight-line text-background-50/80" aria-hidden="true" />
                {flash}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}